import axios from 'axios';

export default {
    list() {
        return axios.get(window.applicationSettings.apiEndpoint + '/role/list')
            .then(response => response.data)
            .catch(error => error.response);
    }
}